import { HttpClient } from '../../httpClient'

export function deleteBoardObjectCollection(
  board_object_collection_id: string
): Promise<void> {
  const url = new URL(
    `board_object_collections/v3/${board_object_collection_id}`,
    window.location.origin
  )

  return HttpClient().delete(url.toString())
}
